import { JsonServiceClient } from '@servicestack/client';
import { useMemo } from 'react';
import useSWR, { SWRConfiguration, SWRResponse } from 'swr';
import { client } from '../api/client';
import { GetSpeakers, GetSpeakersResponse, Registration } from '../api/dtos';
import { useGet } from '@ngt/forms';

const getData = (response?: SWRResponse<GetSpeakersResponse, GetSpeakersResponse>) => response?.data?.registration;

const getError = (response?: SWRResponse<GetSpeakersResponse, GetSpeakersResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetSpeakersResponse, GetSpeakersResponse>) => ({
    registrations: response?.data?.registration
});

export const useSpeakers = (id?: number, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        
        return () => {
            return new GetSpeakers({});
        };
    }, [id])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useSpeakers;